var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Welcome'),_c('footer',[_c('div',{staticClass:"p-4 mt-5 mb-2"},[_c('Socialfooter')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }